"use client";

import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";

import HeroSection from "@/app/[locale]/services/components/HeroSection";
import DeliverySection from "@/app/[locale]/services/components/DeliverySection";
import InformationSection from "@/app/[locale]/services/components/InformationSection";
import AllianceSection from "@/app/[locale]/services/components/AllianceSection";
import VisualSection from "@/app/[locale]/services/components/VisualSection";

const sections = [
    VisualSection,
    HeroSection,
    DeliverySection,
    InformationSection,
    AllianceSection
];

const ServiceClient = () => {
    const langData = useSelector(state => state.language.data);
    const [activeIndex, setActiveIndex] = useState(0);
    const sectionRefs = useRef([]);

    useEffect(() => {
        if (!langData) return;
        const timer = setTimeout(() => {
            const observers = [];
            sectionRefs.current.forEach((el, idx) => {
                if (!el) return;
                const io = new IntersectionObserver(
                    ([entry]) => {
                        if (entry.isIntersecting) {
                            setActiveIndex(idx);
                        }
                    },
                    {
                        threshold: 0,
                        rootMargin: "-55% 0px -40% 0px",
                    }
                );

                io.observe(el);
                observers.push(io);
            });
            return () => observers.forEach(o => o.disconnect());
        }, 0);

        return () => clearTimeout(timer);
    }, [langData]);

    return (
        <>
            {langData && sections.map((Section, idx) => (
                <div
                    key={idx}
                    ref={(el) => {
                        if (el) sectionRefs.current[idx] = el;
                    }}
                >
                    <Section
                        data={langData}
                        index={idx}
                        activeIndex={activeIndex}
                    />
                </div>
            ))}
        </>
    );
};

export default ServiceClient;